import { createSlice } from '@reduxjs/toolkit';

import type { OAuth2Token } from './types';

export const slice = createSlice({
    initialState: {
        johnDeereToken: null as OAuth2Token | null
    },

    name: 'useJohnDeere',

    reducers: {
        johnDeereToken: (state, action) => {
            state.johnDeereToken = action.payload;
        }
    }
});

export default slice.reducer;
